import React, { PropTypes } from 'react';

import { NitroDefinition, NitroDivider, NitroHeading } from 'nitro-components';

import moment from 'moment';

import {
  ALLOCATED_INFO_PAST_VEHICLES,
  ALLOCATED_INFO_PAST_VEHICLES_VEHICLE,
  ALLOCATED_INFO_PAST_VEHICLES_REGISTRATION,
  ALLOCATED_INFO_PAST_ALLOCATION_PERIOD
} from '../content';

const PastVehicles = ({ list }) => {
  return (
    <div>
      <NitroHeading size="1" label={ALLOCATED_INFO_PAST_VEHICLES} align="center" noMargin />
      <NitroDivider sidePanel />
      <div>
        {list.map((item, index) => {
          const startDate = moment(item.StartDate, 'YYYY-MM-DD').format('Do MMM YYYY').toString();
          const endDate = moment(item.EndDate, 'YYYY-MM-DD').format('Do MMM YYYY').toString();

          let driverInfo = [
            {
              title: ALLOCATED_INFO_PAST_VEHICLES_VEHICLE,
              description: `${item.MakeModel}`
            },
            {
              title: ALLOCATED_INFO_PAST_VEHICLES_REGISTRATION,
              description: `${item.RegistrationNumber}`
            },
            {
              title: ALLOCATED_INFO_PAST_ALLOCATION_PERIOD,
              description: `${startDate} - ${endDate}`
            }
          ];
          return (
            <div key={item.LeaseId}>
              <NitroDefinition data={driverInfo} />
              <NitroDivider />
            </div>
          );
        })}
      </div>
    </div>
  );
};

PastVehicles.propTypes = {
  list: PropTypes.array
};

export default PastVehicles;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/PastVehicles.js